import { render, staticRenderFns } from "./TipoVeiculo.vue?vue&type=template&id=421f5a83"
import script from "./TipoVeiculo.vue?vue&type=script&lang=js"
export * from "./TipoVeiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports